export enum AlertTypeEnum {
  Success,
  Error,
  Info,
  Warning,
}
